<div
  class="icon"
  [class]="name + ' icon-' + size"
  [style.margin-left.px]="marginLeft"
  [style.margin-right.px]="marginRight"
></div>
